import React from "react";
import { DeepChat } from "deep-chat-react";

const DeepChatBot = () => {
  const apiKey = import.meta.env.VITE_OPEN_AI_KEY; // Replace with your actual OpenAI API key in .env file

  if (!apiKey) {
    console.error(
      "OpenAI API key is missing. Please check your configuration."
    );
    return <p>API key is not configured. Please contact support.</p>;
  }

  const starterMessages = [
    {
      text: "Hello! Welcome to RealtorBot.",
      role: "assistant",
    },
    {
      text: "How can I help you with your property search today?",
      role: "assistant",
    },
  ];

  return (
    <DeepChat
      // messages={starterMessages}
      // addMessage={"Hello"}
      chatStyle={{
        backgroundColor: "#ffffff",
        borderRadius: "16px",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
        padding: "10px",
      }}
      directConnection={{
        openAI: {
          key: apiKey,
          chat: {
            model: "gpt-3.5-turbo",
            max_tokens: 2000,
            temperature: 0.7,
            system_prompt:
              "You are a helpful assistant that answers all questions.",
          },
        },
      }}
    />
  );
};

export default DeepChatBot;
